export class CSVDataDomainService {
  // NOTE csv出力時にダブルクォーテーションの影響で改行ズレの問い合わせがあり実装。
  // 一旦余分にダブルクォーテーションをつけてcsv出力したときに正常な出力ができるように対応 ""Oniku""" => "O-Toro" とできる。
  static addDoubleQuotationText(text: string): string {
    return text.replace(/"/g, '""');
  }
}
